import * as actionTypes from './actionTypes';
import axios from "axios";
import api from '../../utilities/api';
import { getMessage } from '../../utilities/getMessage';

export const updatePartner23Commission=({
    twoDCommission,
    threeDCommission,
    fourDCommission
},token)=>async dispatch=>{
    dispatch({
        type:actionTypes.UPDATE_PARTNER23C_START
    })
    const options={
        url:`${api}/partnerTwoThreeCommissions`,
        method:'PUT',
        headers:{
            'Authorization':`Bearer ${token}`
        },
        data:{
            twoDCommission,
            threeDCommission,
            fourDCommission
        }
    }
    await axios(options)
            .then(response=>dispatch({
                type:actionTypes.UPDATE_PARTNER23C_SUCCESS,
                payload:response.data
            }))
            .catch(error=>dispatch({
                type:actionTypes.UPDATE_PARTNER23C_FAIL,
                payload:getMessage(error)
            }))
}